import { Component, OnInit } from '@angular/core';
import { BoxInfoAlertService } from '../box-info-alert/box-info-alert.service';
import { RouteService } from '../shared/route.service';
import { Util } from '../shared/Util';
import { environment } from '../../environments/environment';
import { BoxListTruckService } from '../box-list-truck/box-list-truck.service';
import { NgFor, DatePipe, NgIf } from '@angular/common';
import { StatusRoteiroComponent } from '../status-roteiro/status-roteiro.component';
import { BotaoPrimarioComponent } from '../shared/componentes/botao-primario/botao-primario.component';
import { PopupMsgOcComponent } from '../popup-msg-oc/popup-msg-oc.component';

@Component({
    selector: 'box-info-alert',
    templateUrl: './box-info-alert.component.html',
    styleUrls: ['./box-info-alert.component.css'],
    standalone: true,
    imports: [NgFor, StatusRoteiroComponent, DatePipe, NgIf, PopupMsgOcComponent]
})
export class BoxInfoAlertComponent implements OnInit {
  urlOcorrencias = '';

  constructor(
    public boxInfoAlertService: BoxInfoAlertService,
    private boxListTruckService: BoxListTruckService,
  ) { }

  ngOnInit() {
    this.urlOcorrencias = environment.url_telaOcorrencias + '/index.html' + window.location.search;
    this.getInfoAlertRouter();
  }

  async getInfoAlertRouter() {
    const response = await this.boxInfoAlertService.getInfoAlertRouter();    
    this.boxInfoAlertService.alertRouter.forEach(element => {
      element.dadosStatus = this.statusOcorrencia(element.IdStatus)
    });
  }

  abrirOcorrencia(item){   
    const opc6 = {roteiro: this.boxListTruckService.roteiroSelecionado, codigoOcorrencia: item.CodigoOcorrencia }
    const novaData = btoa(new Date().getUTCFullYear() + '-' + (new Date().getUTCMonth() + 1) + '-' + new Date().getUTCDate() + " " + new Date().getHours() + ":" + new Date().getMinutes());
    const analisaUrl = new URL(this.urlOcorrencias);
    analisaUrl.searchParams.set("opc4", novaData);
    const finalUrl = analisaUrl.toString();
    window.open(finalUrl + `&opc6=${btoa(JSON.stringify(opc6))}`, "_blank");
  }

  statusOcorrencia(idStatus){
    switch (idStatus) {
      case 1: 
      case 2: return {msg: 'Em andamento', cor:'#81D4FA', caminho: 'assets/img/icons/icon_pill_oc_andamento.svg'};
      case 3: return {msg:  'Finalizado', cor: '#7FF3B9', caminho: 'assets/img/icons/icon-status-finalizado.svg' };
    }
  }

  private isBase64Image(text: string): boolean {
    const base64ImagePrefixes = ['/9j/', 'iVBOR', 'R0lGO', 'Qk0', 'SUkq'];
    return base64ImagePrefixes.some(prefix => text.trimStart().startsWith(prefix));
  }

  async openModalMsgOc(item: any) {
    const codigoOc = item.CodigoOcorrencia;
    const objMensagem = await this.boxInfoAlertService.getOcorrenciaMensagem(codigoOc);

    const mensagemValida = objMensagem.find(
      (msg: any) => msg?.Mensagem && !this.isBase64Image(msg.Mensagem)
    );

    const mensagemTexto = mensagemValida?.Mensagem ?? '';

    if (mensagemTexto.includes('Motivo:')) {
      const motivoMatch = mensagemTexto.match(/Motivo: <\/b>(.*?)(?:\\n|$)/);
      this.boxInfoAlertService.mensagemModal = motivoMatch ? motivoMatch[1].trim() : '';
    } else {
      this.boxInfoAlertService.mensagemModal = mensagemTexto.trim();
    }

    this.boxInfoAlertService.dataModal = mensagemValida?.Data ?? objMensagem[0]?.Data;

    //seta contexto para o popup-msg-oc usar via callback
    this.boxInfoAlertService.ocorrenciaAtualModal = item;
    this.boxInfoAlertService.abrirOcorrenciaCallback = (ocorrencia) => {
      this.abrirOcorrencia(ocorrencia);
    };

    this.boxInfoAlertService.abrirModalMensagemOc = true;
  }
}
